import { AfterViewChecked, Component, OnInit } from '@angular/core';
// tslint:disable-next-line: max-line-length
import {
  AddressService,
  CoreService,
  CardSetTransformationService,
  CardSetHeaderConfiguration,
  CardSetFooterConfiguration,
  CardSetMenuConfiguration,
  DialogService,
  FormConfigurationService,
  FileService,
  FooterConfiguration,
  FooterLinkColumnConfiguration,
  HeaderService,
  HeaderConfiguration,
  MenuConfigService,
  MenuService,
  UserService,
  FormConfigurationRequest
} from 'dspx-core';
import { take } from 'rxjs/operators';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from './constants/api-endpoints.constants';
import { TEMPLATES, TEMPLATE_NAMES, VERSIONS } from './constants/templates.constants';
import { DashboardCurrentNavigation } from './interfaces/dashboard-current-navigation.interface';
import { AppDataService } from './services/app-data.service';
import { APP_DATA_KEYS, APPLICATION, POP_UP_CODES, POP_UP_TEXTS } from "./constants/app-data.constants";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private appDataService: AppDataService,
    private coreService: CoreService,
    private addressService: AddressService,
    private fileService: FileService,
    private userService: UserService,
    private formConfigurationService: FormConfigurationService,
    private menuService: MenuService,
    private headerService: HeaderService,
    private cardSetTransformationService: CardSetTransformationService,
    private dialogService: DialogService,
    protected menuConfigService: MenuConfigService
  ) {
  }

  environmentBannerMessage: string;
  environmentBannerBgColor: string;
  environmentBannerColor: string;
  //headerConfig: CardSetHeaderConfiguration;
  //footerConfig: CardSetFooterConfiguration;
  headerConfig: any;
  footerConfig: any;
  menuConfig: CardSetMenuConfiguration;

  public headerLinks: any = {};
  public isMenuVisible: boolean = false;  //Set this to false if you have an app that starts on an unauthenticated component.
  public showLogout: boolean = false;     //Set this to false if you have an app that starts on an unauthenticated component.
  //app-data.service.ts has a function called 'getUserDetails' (that you can modify to your liking) which you can call from
  //an authenticated component to set the header config with the user details and display a menu with the logout option.

  ngOnInit() {

    this.menuService.menuLoaded$.subscribe((config) => {
      if (config) {
        this.menuConfig = config;
      }
    });

    this.headerService.headerUpdated$.subscribe((config) => {
      if (config) {
        this.headerConfig = config;
      }
    });

    this.menuConfigService.styleConfigService.layoutMode =
      'static'; /*'overlay';*/ /*'horizontal';*/ /*'slim';*/
    this.menuConfigService.styleConfigService.layoutColor = /*'dark';*/ 'light';
    this.menuConfigService.styleConfigService.darkMenu = /*true;*/ false;
    this.menuConfigService.styleConfigService.ripple = true; /*false;*/
    this.menuConfigService.styleConfigService.inputStyle = 'outlined'; /*'filled';*/

    this.menuConfigService.primengConfig.ripple =
      this.menuConfigService.styleConfigService.ripple;

    this.userService.endpoints = {
      getLoggedInUser: API_ENDPOINTS.user.getLoggedInUser,
    };

    this.formConfigurationService.endpoints = {
      getFormConfig: API_ENDPOINTS.configuration.default,
      getFormSubmissionConfig: API_ENDPOINTS.configuration.custom,
      getFormSubmissionConfigAndResponse: API_ENDPOINTS.formResponse.getConfigAndResponse,
    }

    this.addressService.endpoints = {
      //Note: Do not change the 'addressApiSearchEndpoint' and 'addressApiLgaEndpoint' key names, these are used within dspx-core.
      addressApiSearchEndpoint: API_ENDPOINTS.address.search,
      addressApiLgaEndpoint: API_ENDPOINTS.address.lga
    }

    this.coreService.fileUploadFormIdentifiers = {};
    this.fileService.endpoints = {
      //Note: By default, we use the "Document/FlagForRemoval" endpoint as the fileRemoveEndpoint. This endpoint calls a function that marks the file
      //for deletion and allows the deletion to be deferred to an appropriate time. This is required for the scenario where a form with a file upload
      //control allows edits. If a user edits the form and clicks Remove on an uploaded file, we do not want the file to be immediately deleted
      //from the document management service as the user may not end up saving the form to commit the changes. Therefore, we need to defer the deletion
      //of the file until they save the form, hence the need to mark the file for deletion. If the file can be deleted immediately, use "Document/Remove"
      //as the fileRemoveEndpoint.
      fileUploadEndpoint: 'Document/Upload',
      fileRemoveEndpoint: 'Document/FlagForRemoval',
      //fileRemoveEndpoint: 'Document/Remove',
      fileDownloadEndpoint: 'api/Document/Download'
    }

    this.coreService.applicationFunctions = {};

    this.coreService.conditionFunctions = {};

    this.coreService.pageFunctions = {};

    this.coreService.repeatingPageFunctions = {};

    this.coreService.repeatingSectionFunctions = {};

    // Configure application keys
    this.appDataService.setAppData(APP_DATA_KEYS.maxGridRowCount, this.appDataService.getValueAttributeFromHtmlElement('maxGridRowCount'));

    // Configure the environment banner
    const environmentName =
      this.appDataService.getValueAttributeFromHtmlElement('environmentName');
    if (environmentName) {
      this.environmentBannerMessage = `You are using the ${environmentName} environment`;
    }
    const environmentBannerBgColor =
      this.appDataService.getValueAttributeFromHtmlElement(
        'environmentBannerBgColor'
      );
    if (environmentBannerBgColor) {
      this.environmentBannerBgColor = environmentBannerBgColor;
    }
    const environmentBannerColor =
      this.appDataService.getValueAttributeFromHtmlElement(
        'environmentBannerColor'
      );
    if (environmentBannerColor) {
      this.environmentBannerColor = environmentBannerColor;
    }

    // we are using MS Identity so redirect to MicrosoftIdentity Web UI Account Controller action
    this.userService.logout = () => {
      window.open('MicrosoftIdentity/Account/SignOut', '_self');
    };

    // Cardset Layout header config structure.
    //this.headerConfig = {
    //  applicationTitle: {
    //    label: APPLICATION.title,
    //  },
    //  applicationLogo: {
    //    source: APPLICATION.logo,
    //  },
    //};

    // Classic Layout header config structure.
    this.headerConfig = {
      applicationTitle: APPLICATION.title,
      applicationLogo: {
        source: APPLICATION.logo,
      },
    };

    // Configure the footer
    this.footerConfig = {
      lightModeLogo: '/assets/images/sgv-logo-dark.png',
      darkModeLogo: '/assets/images/sgv-logo.png',
      atsiLogo: '/assets/images/logo-a-tsi-flag.svg',
      prideLogo: '/assets/images/flag-pride.svg',
      prideDeclaration:
        'The Department of Health celebrates, values and includes people of all backgrounds, genders, sexualities, cultures, bodies and abilities.',
      atsiDeclaration:
        'The department acknowledges Aboriginal and Torres Strait Islander people as the Traditional Custodians of the land and acknowledges and pays respect to their Elders, past and present.',
      footerLinkColumns: [
        {
          heading: 'About the site',
          links: [
            {
              label: 'Terms of Use',
              altText: 'Terms of Use',
              url: 'https://foodtrader.vic.gov.au/terms-of-use/'
            },
            {
              label: 'Accessibility',
              altText: 'Accessibility',
              url: 'https://foodtrader.vic.gov.au/accessibility/'
            }
          ],
        },
        {
          heading: 'Information and assistance',
          links: [
            {
              label: 'Health.vic',
              altText: 'Health.vic',
              url: 'https://www.health.vic.gov.au/',
            },
            {
              label: 'About Us',
              altText: 'About Us',
              url: 'https://www.health.vic.gov.au/about',
            },
            {
              label: 'Contact us',
              altText: 'Contact us',
              // url: 'mailto:<dh.app_support_email>@health.vic.gov.au',
            },
          ],
        },
      ],
      departmentName: 'Department of Health',
      governmentName: 'State Government of Victoria, Australia',
      showAppLogo: false,
      lightModeAppLogo: '/assets/images/OSCAR_Logo_V__RGB__Navy_Turquoise.svg',
      darkModeAppLogo: '/assets/images/OSCAR_Logo_V__RGB__Navy_Turquoise.svg',
    };

    // Get Logged In User and update header
    // this.userService
    //   .getLoggedInUser('getLoggedInUser')
    //   .pipe(take(1))
    //   .subscribe((userProfile) => {
    //     if (userProfile.user !== null) {
    //       this.headerConfig.loggedInUser = {
    //         name: userProfile.fullName,
    //         imageSource: '/assets/images/avatar.png',
    //         imageDescription: userProfile.fullName,
    //         menuSubItems: [
    //           {
    //             label: 'Logout',
    //             icon: 'pi pi-fw pi-sign-out',
    //             routerLink: 'logout',
    //           },
    //         ],
    //       };
    //     }
    //     this.headerService.onHeaderUpdated(this.headerConfig);
    //   });

    // Configure the menu
    // const request: FormConfigurationRequest = {
    //   apiEndpointKey: API_ENDPOINT_KEYS.getFormConfig,
    //   templateId: TEMPLATES.menu,
    //   versionNo: VERSIONS.latest,
    //   entityId: null,
    // };
    // this.formConfigurationService
    //   .getFormConfigAndResponse(request)
    //   .pipe(take(1))
    //   .subscribe((data) => {
    //     this.menuConfig =
    //       this.cardSetTransformationService.extractMenuConfigFromFormConfig([
    //         data.configData.config,
    //       ]);
    //     this.menuService.onMenuLoad(this.menuConfig);
    //   });

    this.dialogService.updatePopupText(
      POP_UP_CODES.common.confirmDocumentDeletion,
      POP_UP_TEXTS.common.confirmDocumentDeletion);

  }

}
